
const fields = [
  {
    type: "bsx-input",
    inputType: "text",
    label: "標題",
    model: "title",
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "bsx-input",
    inputType: "text",
    label: "副標題",
    model: "sub_title",
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: "x-QuillEditor",
    label: "消息內容",
    model: "contents",
    required: true,
    validator: function () {
      this.validation();
    },
  },
  {
    type: 'bsx-toggle',
    label: '狀態',
    model: 'status',
    required: true,
    textOn: '上架',
    textOff: '下架',
    valueOn: 'ON',
    valueOff: 'OFF',
  },
  {
    type: 'bsx-toggle',
    label: '推播狀態',
    model: 'is_need_publish',
    required: true,
    textOn: '啟用推播',
    textOff: '停用推播',
    valueOn: 1,
    valueOff: 0,
    disabled: (model) => model.id,
  }
];

export default fields;
